<template>
	<div
		class="social-community"
		:data-chronicle="chronicId"
		v-metric="{ module: omnitureModule }"
	>
		<div class="social-media-cont">
			<div class="social-media-wrap">
				<h3>Follow WebMD on Social Media</h3>
				<div
					class="sc-icons"
					:class="{'themed': themed }"
				>
					<a
						:href="'https://www.facebook.com/WebMD/'"
						v-metric="{ link: 'flw-fb', type: 'ad-hoc' }"
						aria-label="facebook"
						rel="nofollow"
					>
						<!-- eslint-disable max-len -->
						<svg
							width="22"
							height="23"
							viewBox="0 0 22 23"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M22 11.9453C22 5.87018 17.0751 0.945312 11 0.945312C4.92486 0.945312 0 5.87018 0 11.9453C0 17.4356 4.02252 21.9865 9.28125 22.8117V15.125H6.48828V11.9453H9.28125V9.52188C9.28125 6.765 10.9235 5.24219 13.4361 5.24219C14.6397 5.24219 15.8984 5.45703 15.8984 5.45703V8.16406H14.5114C13.145 8.16406 12.7188 9.01205 12.7188 9.88195V11.9453H15.7695L15.2818 15.125H12.7188V22.8117C17.9775 21.9865 22 17.4359 22 11.9453Z"
							/>
						</svg>
					</a>
					<a
						:href="'https://x.com/webmd'"
						v-metric="{ link: 'flw-tw', type: 'ad-hoc' }"
						aria-label="X"
						rel="nofollow"
					>
						<svg 
							width="21" 
							height="21" 
							viewBox="0 0 1200 1227"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path 
								d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"
							/>
						</svg>
					</a>
					<a
						:href="'https://www.instagram.com/WebMD/'"
						v-metric="{ link: 'flw-inst', type: 'ad-hoc' }"
						aria-label="instagram"
						rel="nofollow"
					>
						<svg
							width="23"
							height="23"
							viewBox="0 0 23 23"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M11.497 7.77708C9.47722 7.77708 7.82888 9.42545 7.82888 11.4453C7.82888 13.4652 9.47722 15.1135 11.497 15.1135C13.5169 15.1135 15.1652 13.4652 15.1652 11.4453C15.1652 9.42545 13.5169 7.77708 11.497 7.77708ZM22.4988 11.4453C22.4988 9.92629 22.5125 8.42102 22.4272 6.90474C22.3419 5.14355 21.9402 3.5805 20.6523 2.29263C19.3617 1.00201 17.8014 0.602987 16.0403 0.517679C14.5213 0.432372 13.016 0.446131 11.4998 0.446131C9.9808 0.446131 8.47556 0.432372 6.95931 0.517679C5.19815 0.602987 3.63513 1.00476 2.34728 2.29263C1.05668 3.58325 0.657672 5.14355 0.572365 6.90474C0.487059 8.42377 0.500819 9.92904 0.500819 11.4453C0.500819 12.9616 0.487059 14.4696 0.572365 15.9859C0.657672 17.7471 1.05944 19.3101 2.34728 20.598C3.63788 21.8886 5.19815 22.2876 6.95931 22.3729C8.47831 22.4583 9.98355 22.4445 11.4998 22.4445C13.0188 22.4445 14.524 22.4583 16.0403 22.3729C17.8014 22.2876 19.3645 21.8859 20.6523 20.598C21.9429 19.3074 22.3419 17.7471 22.4272 15.9859C22.5153 14.4696 22.4988 12.9643 22.4988 11.4453ZM11.497 17.0894C8.37374 17.0894 5.85309 14.5687 5.85309 11.4453C5.85309 8.32195 8.37374 5.80125 11.497 5.80125C14.6203 5.80125 17.141 8.32195 17.141 11.4453C17.141 14.5687 14.6203 17.0894 11.497 17.0894ZM17.3722 6.88823C16.6429 6.88823 16.054 6.29934 16.054 5.57009C16.054 4.84085 16.6429 4.25195 17.3722 4.25195C18.1014 4.25195 18.6903 4.84085 18.6903 5.57009C18.6905 5.74325 18.6565 5.91476 18.5904 6.07478C18.5242 6.2348 18.4271 6.3802 18.3047 6.50264C18.1822 6.62509 18.0369 6.72217 17.8768 6.78834C17.7168 6.8545 17.5453 6.88845 17.3722 6.88823Z" />
						</svg>
					</a>
					<a
						:href="'https://www.tiktok.com/@webmd/'"
						v-metric="{ link: 'flw-tik', type: 'ad-hoc' }"
						aria-label="tiktok"
						rel="nofollow"
					>
						<svg
							width="23"
							height="23"
							viewBox="0 0 23 23"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M22.5 7.21454V11.4453C22.5 11.6697 22.4109 11.8849 22.2522 12.0436C22.0935 12.2023 21.8783 12.2915 21.6538 12.2915C19.8863 12.2961 18.1441 11.8714 16.5769 11.054V14.8299C16.5771 16.3592 16.1411 17.8568 15.32 19.147C14.4989 20.4371 13.3268 21.4663 11.9413 22.1136C10.5558 22.761 9.01435 22.9997 7.49794 22.8018C5.98153 22.6038 4.55305 21.9774 3.38016 20.996C2.20728 20.0147 1.33866 18.7192 0.876261 17.2615C0.413862 15.8038 0.376871 14.2444 0.769629 12.7664C1.16239 11.2884 1.9686 9.95317 3.09363 8.91732C4.21866 7.88146 5.61583 7.18802 7.12115 6.91839C7.24193 6.89672 7.36598 6.90157 7.48469 6.93262C7.60341 6.96367 7.71395 7.02017 7.80865 7.0982C7.90627 7.17699 7.98464 7.277 8.03779 7.39064C8.09094 7.50427 8.11748 7.62853 8.11538 7.75397V12.154C8.11584 12.3142 8.07021 12.4712 7.98395 12.6062C7.89769 12.7412 7.77442 12.8486 7.62885 12.9155C7.28737 13.0781 6.99575 13.3294 6.78435 13.643C6.57295 13.9566 6.4495 14.3212 6.42687 14.6988C6.40424 15.0763 6.48325 15.453 6.65567 15.7897C6.82809 16.1263 7.08762 16.4106 7.40722 16.6128C7.72682 16.8151 8.09481 16.928 8.47285 16.9397C8.8509 16.9514 9.22518 16.8616 9.55671 16.6795C9.88823 16.4975 10.1649 16.2298 10.3578 15.9045C10.5508 15.5792 10.653 15.2082 10.6538 14.8299V1.29147C10.6538 1.06705 10.743 0.85183 10.9017 0.693145C11.0604 0.534461 11.2756 0.445313 11.5 0.445312H15.7308C15.9552 0.445313 16.1704 0.534461 16.3291 0.693145C16.4878 0.85183 16.5769 1.06705 16.5769 1.29147C16.5769 2.63795 17.1118 3.92929 18.0639 4.88139C19.016 5.8335 20.3074 6.36839 21.6538 6.36839C21.8783 6.36839 22.0935 6.45754 22.2522 6.61622C22.4109 6.77491 22.5 6.99013 22.5 7.21454Z" />
						</svg>
					</a>
					<a
						:href="'https://www.pinterest.com/webmd/'"
						v-metric="{ link: 'flw-pin', type: 'ad-hoc' }"
						aria-label="pinterest"
						rel="nofollow"
					>
						<svg 
							width="23" 
							height="23" 
							viewBox="0 0 23 23" 
							fill="none" 
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M11.0075 -0.000486067C8.4426 -0.00211271 5.95775 0.892585 3.9826 2.52891C2.00744 4.16523 0.666171 6.44031 0.19069 8.96077C-0.28479 11.4812 0.135414 14.0886 1.37865 16.3321C2.62188 18.5755 4.60998 20.314 6.9992 21.247C6.90295 20.3766 6.81494 19.0387 7.03633 18.0885C7.23709 17.2291 8.32614 12.6199 8.32614 12.6199C8.32614 12.6199 7.9975 11.9612 7.9975 10.9877C7.9975 9.45721 8.88441 8.3159 9.98859 8.3159C10.9264 8.3159 11.3802 9.01994 11.3802 9.8656C11.3802 10.8089 10.7793 12.2197 10.4685 13.5274C10.21 14.622 11.0185 15.5157 12.0979 15.5157C14.0533 15.5157 15.5562 13.4531 15.5562 10.4775C15.5562 7.84426 13.6628 6.00305 10.9608 6.00305C7.83112 6.00305 5.99403 8.35028 5.99403 10.7759C5.99403 11.7219 6.35842 12.7354 6.81219 13.2868C6.85127 13.3283 6.8789 13.3793 6.8924 13.4347C6.90589 13.4902 6.90479 13.5482 6.8892 13.603C6.80532 13.9495 6.61968 14.6976 6.58393 14.8502C6.5358 15.051 6.42442 15.0936 6.21541 14.9973C4.84035 14.3579 3.98231 12.349 3.98231 10.7346C3.98231 7.26536 6.50418 4.07933 11.2509 4.07933C15.0667 4.07933 18.0327 6.79783 18.0327 10.4321C18.0327 14.2232 15.6415 17.2745 12.3248 17.2745C11.2096 17.2745 10.1618 16.6955 9.80296 16.0108L9.11818 18.6261C8.86929 19.5818 8.19826 20.7795 7.74999 21.5096C9.26252 21.9773 10.8582 22.113 12.428 21.9074C13.9977 21.7018 15.5046 21.1598 16.8457 20.3184C18.1868 19.4771 19.3305 18.3561 20.1986 17.0322C21.0668 15.7082 21.6389 14.2125 21.876 12.6472C22.113 11.0818 22.0094 9.48379 21.5722 7.96217C21.135 6.44056 20.3745 5.03124 19.3427 3.83049C18.3109 2.62975 17.032 1.66587 15.5935 1.00471C14.155 0.343541 12.5907 0.00066994 11.0075 -0.000486067Z" fill="white"/>
						</svg>
					</a>
					<a
						:href="'https://www.whatsapp.com/channel/0029VareKvA0wajrKr01nA1n'"
						v-metric="{ link: 'flw-whapp', type: 'ad-hoc' }"
						aria-label="whatsapp"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M11.869 0.960083C5.85381 0.960083 0.959909 5.85398 0.959909 11.8691C0.959909 13.7474 1.44513 15.5943 2.36528 17.2241L0.977459 22.1758C0.931925 22.3385 0.976036 22.5131 1.09366 22.634C1.18426 22.7274 1.30758 22.7782 1.43422 22.7782C1.47216 22.7782 1.51058 22.7735 1.54805 22.7644L6.7161 21.4843C8.29411 22.3314 10.0713 22.7782 11.869 22.7782C17.8841 22.7782 22.778 17.8843 22.778 11.8691C22.778 5.85398 17.8841 0.960083 11.869 0.960083ZM17.3567 15.7186C17.1233 16.3646 16.004 16.9542 15.4661 17.0334C14.9833 17.1041 14.3724 17.1344 13.7017 16.9238C13.2952 16.7958 12.7735 16.626 12.1052 16.3409C9.29585 15.1428 7.46123 12.3496 7.32084 12.1651C7.18092 11.9806 6.17728 10.6658 6.17728 9.30504C6.17728 7.94425 6.9006 7.275 7.15768 6.99801C7.41475 6.72101 7.71783 6.65176 7.90471 6.65176C8.09159 6.65176 8.27799 6.65414 8.44162 6.66172C8.6138 6.67026 8.84479 6.59674 9.07198 7.13651C9.30534 7.6905 9.86549 9.05128 9.93474 9.19025C10.0049 9.32875 10.0514 9.49049 9.95846 9.675C9.86549 9.8595 9.81901 9.97476 9.67862 10.1365C9.53822 10.2982 9.38455 10.497 9.25838 10.6212C9.11799 10.7593 8.97237 10.9087 9.13554 11.1857C9.2987 11.4627 9.86075 12.3681 10.6936 13.1014C11.7632 14.0434 12.6658 14.3355 12.9456 14.474C13.2255 14.6125 13.3891 14.5893 13.5523 14.4048C13.7154 14.2198 14.2524 13.597 14.4388 13.3205C14.6252 13.044 14.812 13.0895 15.0691 13.182C15.3262 13.274 16.7031 13.9428 16.9829 14.0813C17.2628 14.2198 17.4497 14.2891 17.5199 14.4043C17.5901 14.5191 17.5901 15.0731 17.3567 15.7186Z" fill="white"/>
						</svg>
					</a>
					<!-- eslint-enable max-len -->
				</div>
			</div>
			<div class="separator"></div>
			<div class="hp-apps-container">
				<h3>Download WebMD App</h3>
				<div
					class="img-cont"
					v-metric="{ module: 'dnl' }"
				>
					<a
						href="https://taps.io/Bzg3Q"
						v-metric="{ link: 'iphone', type: 'ad-hoc' }"
						aria-label="App Store"
						rel="nofollow"
					>
						<img :src="`${appStoreImg}`" alt="App Store Image" />
					</a>
					<a
						href="https://taps.io/Bzg2w"
						v-metric="{ link: 'android', type: 'ad-hoc' }"
						aria-label="Android Store"
						rel="nofollow"
					>
						<img :src="`${androidStoreImg}`" alt="Andriod Store Image" />
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import offsiteLinks from 'webmd-offsite/index.es6';

export default {
	data() {
		return {
			resizer: '?resize=550px:*&output-quality=50',
			appStoreImg: 'https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/tocs/community/thumbnails/ios-dwnld.png?resize=90:32',
			androidStoreImg: 'https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/tocs/community/thumbnails/android-dwnld.png?resize=90:32',
			resizerforapp: '?resize=484px:*&output-quality=50',
			omnitureModule: 'ftr-com',
		};
	},
	props: {
		themed: {
			type: Object,
			default: null,
		},
	},
	mixins: [offsiteLinks],
	mounted() {
		const self = this;
		self.handleOffsiteLinks();
	},
};
</script>

<style lang="scss" src="../../src/styles/_socialShare.scss">
</style>
